import { render, staticRenderFns } from "./checklist_answers.vue?vue&type=template&id=a26542b8&scoped=true&"
import script from "./checklist_answers.vue?vue&type=script&lang=js&"
export * from "./checklist_answers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26542b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26542b8')) {
      api.createRecord('a26542b8', component.options)
    } else {
      api.reload('a26542b8', component.options)
    }
    module.hot.accept("./checklist_answers.vue?vue&type=template&id=a26542b8&scoped=true&", function () {
      api.rerender('a26542b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/scheck/tabs/checklist_answers.vue"
export default component.exports